//@ts-nocheck
import React, { useEffect, useState, useRef, useLocation } from "react";
import {
  Button,
  Input,
  Select,
  Col,
  Row,
  DatePicker,
  Tabs,
  Radio,
  message,
} from "antd";
import {
  LeftOutlined,
  EditOutlined,
  DeleteOutlined,
  RightOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import {
  createInventory,
  deleteInventory,
  createStatus,
  deleteStatus,
  exportInventoryInStockExcel,
  exportInventoryStockWithIncomingExcel,
  getInventories,
  getInventoryById,
  getLatestInventory,
  getManufacturers,
  getStatuses,
  updateInventory,
  updateStatus,
  createQuoteWtb,
  bulkImportInventory,
  type InventoryResponse,
} from "../../utils/API";
import NavigationDropdown from "../../Components/NavigationDropDown";
import PageLogoutButton from "../../Components/PageLogoutButton";
import CommonHeader from "../../Components/commonHeader";
import { normalizeSortRules, sortRulesToQuery, type SortRule } from "../../utils/sortRules";

const INVENTORY_EXPORT_COLUMNS = [
  { label: "Status", key: "status" },
  { label: "Manufacturer", key: "manu" },
  { label: "Model", key: "model" },
  { label: "Options", key: "opt" },
  { label: "List Price", key: "listPrice" },
  { label: "Description", key: "desc" },
  { label: "Serial Number", key: "serialNumber" },
  { label: "QTY", key: "quantity" },
  { label: "Cost", key: "cost" },
  { label: "Sell Dealer Price", key: "sellDealer" },
  { label: "Condition", key: "condition" },
  { label: "Functional", key: "functional" },
  { label: "Buyer", key: "buyer" },
  { label: "Location", key: "location" },
  { label: "Date Purchased", key: "datePurchased" },
  { label: "Ship Weight", key: "shipWeight" },
  { label: "Accessories", key: "accessories" },
  { label: "Comments", key: "comments" },
  { label: "Monthly Rental", key: "monthlyRental" },
  { label: "End User Rental", key: "endUserRental" },
  { label: "User Manual", key: "userManual" },
  { label: "Cal Status", key: "calcStatus" },
  { label: "Cal Date", key: "calcDate" },
  { label: "Cal Valid Date", key: "calcValidDate" },
  { label: "Cal Cert By", key: "calcCertBy" },
  { label: "Category", key: "eqCategoriesCatName" },
  { label: "Sub Category", key: "eqSubCategoriesSubCatName" },
  { label: "TestMart Price", key: "tmartPrice" },
  { label: "TestMart Country", key: "tmartCountry" },
  { label: "TestMart Ship Time", key: "tmartShipTime" },
  { label: "TestMart Location Zip", key: "tmartLocationZip" },
  { label: "TestMart Warranty", key: "tmartWarrenty" },
];

const INVENTORY_SORT_KEYS = INVENTORY_EXPORT_COLUMNS.map((column) => column.key);
// import InventoryItem from "./InventoryItem"; // Adjust path as needed

// import React from "react";
// import { Button, Input, Select, Col, Row, DatePicker, Radio } from "antd";

type StatusOption = {
  id: number;
  value: string;
  label: string;
  type: string;
};
type ActiveInventoryFilter =
  | { type: "none" }
  | { type: "inStock" }
  | { type: "model"; value: string };

const TMART_DEFAULTS = {
  tmartCountry: "United States",
  tmartUsername: "sales@alliancetesteq.com",
  tmartShipTime: "1-2 days after purchase order, Unless otherwise noted. Calibration can add 7 to 10 days.",
  tmartLocationZip: "01570",
  tmartWarrenty: "Dealer: 30 days with a 5 day ROR, End Users: 90 day with a 10 day ROR - Extended warranties available.",
};

const getEmptyInventory = (): InventoryResponse => ({
  invid: 0,
  status: undefined,
  manu: "",
  model: "",
  listPrice: undefined,
  opt: "",
  desc: "",
  serialNumber: "",
  quantity: undefined,
  cost: undefined,
  sellDealer: undefined,
  monthlyRental: undefined,
  endUserRental: undefined,
  buyer: "",
  shipWeight: undefined,
  location: "",
  datePurchased: undefined,
  accessories: "",
  comments: "",
  eqCategoriesCatName: "",
  eqSubCategoriesSubCatName: "",
  ...TMART_DEFAULTS,
});

const STATUS_TYPE_INVENTORY = "inventory";

type FindValues = {
  manu: string;
  model: string;
  serialNumber: string;
  status: string;
  location: string;
  buyer: string;
  opt: string;
  desc: string;
  listPrice: string;
  quantity: string;
  cost: string;
  sellDealer: string;
  monthlyRental: string;
  endUserRental: string;
  shipWeight: string;
  accessories: string;
  comments: string;
  eqCategoriesCatName: string;
  eqSubCategoriesSubCatName: string;
  datePurchased: string;
};

interface InventoryItemProps {
  itemNumber?: number;
  item?: InventoryResponse;
  statusOptions: StatusOption[];
  manufacturerOptions: { value: string; label: string }[];
  onOpenStatusModal: () => void;
  onChange: (patch: Partial<InventoryResponse>) => void;
  onBlurSave: () => void;
  onAddWts: () => void;
  isFindMode?: boolean;
  findValues?: FindValues;
  onFindChange?: (field: keyof FindValues, value: string) => void;
  onPerformFind?: () => void;
}

const searchIconStyle: React.CSSProperties = {
  position: "absolute",
  right: 5,
  top: "50%",
  transform: "translateY(-50%)",
  color: "#888",
  fontSize: 11,
  pointerEvents: "none",
  zIndex: 1,
};

const FI: React.FC<{
  className: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  autoFocus?: boolean;
}> = ({ className, value, onChange, onKeyDown, autoFocus }) => (
  <div style={{ position: "relative", width: "100%" }}>
    <Input
      className={className}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      autoFocus={autoFocus}
    />
    <SearchOutlined style={searchIconStyle} />
  </div>
);

const InventoryItem = ({
  itemNumber = 1,
  item,
  statusOptions,
  manufacturerOptions,
  onOpenStatusModal,
  onChange,
  onBlurSave,
  onAddWts,
  isFindMode = false,
  findValues,
  onFindChange,
  onPerformFind,
}: InventoryItemProps) => {
  const [statusValue, setStatusValue] = useState<string | undefined>(
    item?.status || undefined,
  );
  useEffect(() => {
    setStatusValue(item?.status || undefined);
  }, [item?.status]);

  const fv = findValues ?? {
    manu: "", model: "", serialNumber: "", status: "", location: "", buyer: "",
    opt: "", desc: "", listPrice: "", quantity: "", cost: "", sellDealer: "",
    monthlyRental: "", endUserRental: "", shipWeight: "", accessories: "",
    comments: "", eqCategoriesCatName: "", eqSubCategoriesSubCatName: "", datePurchased: "",
  };

  const handleFindKey = (e: React.KeyboardEvent) => {
    if (e.key !== "Enter") return;
    // Mark handled so CommonHeader's page-wide Enter listener doesn't search twice.
    e.preventDefault();
    onPerformFind?.();
  };

  return (
    <div
      className="bg-white p-3 rounded-2xl flex flex-col gap-1 mb-4"
    >
      {/* Row 1: Status */}
      <Row className="mb-1">
        <Col span={24}>
          <div className="flex gap-2 items-center">
            <label className="text-xs">Status</label>
            {isFindMode ? (
              <Select
                className="w-1/3 h-[20px] text-xs status-box-select"
                size="small"
                value={fv.status || undefined}
                placeholder="Search status..."
                allowClear
                autoFocus
                style={{}}
                options={statusOptions}
                onChange={(value) => onFindChange?.("status", value || "")}
                onKeyDown={handleFindKey}
              />
            ) : (
              <Select
                className="w-1/3 h-[20px] text-xs status-box-select"
                size="small"
                value={statusValue}
                placeholder="Select"
                options={[
                  ...statusOptions,
                  { value: "edit_status", label: "✎ Edit Status..." },
                ]}
                onChange={(value) => {
                  if (value === "edit_status") {
                    onOpenStatusModal();
                    return;
                  }
                  setStatusValue(value);
                  onChange({ status: value });
                }}
                onBlur={onBlurSave}
              />
            )}
          </div>
        </Col>
      </Row>

      {/* Row 2: Manu, Model, Options */}
      <Row gutter={12}>
        <Col span={8}>
          <Row gutter={12}>
            <Col span={12}>
              <div className="flex flex-col gap-1">
                <label className="text-xs">Manu</label>
                {isFindMode ? (
                  <Select
                    showSearch
                    allowClear
                    className="w-full text-xs"
                    size="small"
                    value={fv.manu || undefined}
                    placeholder="Search manu..."
                    options={manufacturerOptions}
                    filterOption={(input, option) =>
                      String(option?.label || "")
                        .toLowerCase()
                        .startsWith(input.toLowerCase())
                    }
                    onChange={(value) => onFindChange?.("manu", value || "")}
                    onKeyDown={handleFindKey}
                  />
                ) : (
                  <Select
                    showSearch
                    className="w-full text-xs"
                    size="small"
                    value={item?.manu || undefined}
                    options={manufacturerOptions}
                    placeholder="Select manufacturer"
                    onChange={(value) => onChange({ manu: value || "" })}
                    filterOption={(input, option) =>
                      String(option?.label || "")
                        .toLowerCase()
                        .startsWith(input.toLowerCase())
                    }
                    onBlur={onBlurSave}
                  />
                )}
              </div>
            </Col>
            <Col span={12}>
              <div className="flex flex-col gap-1">
                <label className="text-xs">Model</label>
                {isFindMode ? (
                  <FI
                    className="Allinput !h-[25px] text-xs model-box-input"
                    value={fv.model}
                    onChange={(e) => onFindChange?.("model", e.target.value)}
                    onKeyDown={handleFindKey}
                  />
                ) : (
                  <Input
                    className="Allinput !h-[25px] text-xs model-box-input"
                    value={item?.model || ""}
                    onChange={(e) => onChange({ model: e.target.value })}
                    onBlur={onBlurSave}
                  />
                )}
              </div>
            </Col>

            <Col span={24} className="mt-2">
              <div className="flex items-center gap-1">
                <label className="text-xs w-20">List Price</label>
                {isFindMode ? (
                  <FI
                    className="Allinput !h-[25px] !w-30 text-xs"
                    value={fv.listPrice}
                    onChange={(e) => onFindChange?.("listPrice", e.target.value)}
                    onKeyDown={handleFindKey}
                  />
                ) : (
                  <Input
                    className="Allinput !h-[25px] !w-30 text-xs"
                    value={item?.listPrice ?? ""}
                    onChange={(e) => onChange({ listPrice: Number(e.target.value) || undefined })}
                    onBlur={onBlurSave}
                  />
                )}
              </div>
            </Col>
          </Row>
        </Col>

        <Col span={6}>
          <div className="flex flex-col gap-1 h-full">
            <label className="text-xs">Options</label>
            <Input.TextArea
              rows={2}
              style={{ resize: "none" }}
              className="text-xs"
              value={isFindMode ? fv.opt : (item?.opt || "")}
              onChange={(e) =>
                isFindMode
                  ? onFindChange?.("opt", e.target.value)
                  : onChange({ opt: e.target.value })
              }
              onBlur={isFindMode ? undefined : onBlurSave}
            />
          </div>
        </Col>
        <Col span={10}>
          <div className="flex flex-col gap-1 h-full">
            <label className="text-xs">Desc</label>
            <Input.TextArea
              rows={2}
              style={{ resize: "none" }}
              className="text-xs"
              value={isFindMode ? fv.desc : (item?.desc || "")}
              onChange={(e) =>
                isFindMode
                  ? onFindChange?.("desc", e.target.value)
                  : onChange({ desc: e.target.value })
              }
              onBlur={isFindMode ? undefined : onBlurSave}
            />
          </div>
        </Col>
      </Row>

      {/* Row 3: Pricing and Quantity */}
      <Row gutter={12}>
        <div className="flex items-center">
          <Col span={5}>
            <div className="flex flex-col gap-1">
              <label className="text-xs">Serial</label>
              {isFindMode ? (
                <FI
                  className="Allinput !h-[25px] text-xs"
                  value={fv.serialNumber}
                  onChange={(e) => onFindChange?.("serialNumber", e.target.value)}
                  onKeyDown={handleFindKey}
                />
              ) : (
                <Input
                  className="Allinput !h-[25px] text-xs"
                  value={item?.serialNumber || ""}
                  onChange={(e) => onChange({ serialNumber: e.target.value })}
                  onBlur={onBlurSave}
                />
              )}
            </div>
          </Col>
          <Col span={2}>
            <div className="flex flex-col items-center gap-1">
              <label className="text-xs">Qty</label>
              {isFindMode ? (
                <FI className="Allinput !h-[25px] text-xs" value={fv.quantity} onChange={(e) => onFindChange?.("quantity", e.target.value)} onKeyDown={handleFindKey} />
              ) : (
                <Input
                  className="Allinput !h-[25px] text-xs"
                  value={item?.quantity ?? ""}
                  onChange={(e) => onChange({ quantity: Number(e.target.value) || undefined })}
                  onBlur={onBlurSave}
                />
              )}
            </div>
          </Col>
          <Col span={3}>
            <div className="flex flex-col items-center gap-1">
              <label className="text-xs">Cost</label>
              {isFindMode ? (
                <FI className="Allinput !h-[25px] text-xs" value={fv.cost} onChange={(e) => onFindChange?.("cost", e.target.value)} onKeyDown={handleFindKey} />
              ) : (
                <Input
                  className="Allinput !h-[25px] text-xs"
                  value={item?.cost ?? ""}
                  onChange={(e) => onChange({ cost: Number(e.target.value) || undefined })}
                  onBlur={onBlurSave}
                />
              )}
            </div>
          </Col>
          <Col span={4}>
            <div className="flex flex-col items-center gap-1">
              <label className="text-xs">One Price</label>
              {isFindMode ? (
                <FI className="Allinput !h-[25px] text-xs one-price-box-input" value={fv.sellDealer} onChange={(e) => onFindChange?.("sellDealer", e.target.value)} onKeyDown={handleFindKey} />
              ) : (
                <Input
                  className="Allinput !h-[25px] text-xs one-price-box-input"
                  value={item?.sellDealer ?? ""}
                  onChange={(e) => onChange({ sellDealer: Number(e.target.value) || undefined })}
                  onBlur={onBlurSave}
                />
              )}
            </div>
          </Col>
          <Col span={4}>
            <div className="flex flex-col items-center gap-1">
              <label className="text-xs">Dealer Rental</label>
              {isFindMode ? (
                <FI className="Allinput !h-[25px] text-xs" value={fv.monthlyRental} onChange={(e) => onFindChange?.("monthlyRental", e.target.value)} onKeyDown={handleFindKey} />
              ) : (
                <Input
                  className="Allinput !h-[25px] text-xs"
                  value={item?.monthlyRental ?? ""}
                  onChange={(e) => onChange({ monthlyRental: Number(e.target.value) || undefined })}
                  onBlur={onBlurSave}
                />
              )}
            </div>
          </Col>
          <Col span={4}>
            <div className="flex flex-col items-center gap-1">
              <label className="text-xs">End User Rental</label>
              {isFindMode ? (
                <FI className="Allinput !h-[25px] text-xs" value={fv.endUserRental} onChange={(e) => onFindChange?.("endUserRental", e.target.value)} onKeyDown={handleFindKey} />
              ) : (
                <Input
                  className="Allinput !h-[25px] text-xs"
                  value={item?.endUserRental ?? ""}
                  onChange={(e) => onChange({ endUserRental: e.target.value })}
                  onBlur={onBlurSave}
                />
              )}
            </div>
          </Col>
        </div>
      </Row>

      <Row gutter={16} align="stretch">
        <Col span={12}>
          <div className="flex flex-col gap-1">
            <Row gutter={24}>
              <Col span={12}>
                <div className="flex gap-2 items-center mt-2">
                  <label className="text-xs">Conditions:</label>
                  <label className="text-xs">Used</label>
                </div>
              </Col>
              <Col span={12}>
                <div className="flex items-center gap-1 mt-1">
                  <label className="text-xs">Buyer</label>
                  {isFindMode ? (
                    <FI
                      className="Allinput !h-[25px] text-xs"
                      value={fv.buyer}
                      onChange={(e) => onFindChange?.("buyer", e.target.value)}
                      onKeyDown={handleFindKey}
                    />
                  ) : (
                    <Input
                      className="Allinput !h-[25px] text-xs"
                      value={item?.buyer || ""}
                      onChange={(e) => onChange({ buyer: e.target.value })}
                      onBlur={onBlurSave}
                    />
                  )}
                </div>
              </Col>
            </Row>

            <div className="flex items-center gap-1 mt-1">
              <label className="text-xs mr-4">Weight:</label>
              {isFindMode ? (
                <FI className="Allinput !h-[25px] text-xs" value={fv.shipWeight} onChange={(e) => onFindChange?.("shipWeight", e.target.value)} onKeyDown={handleFindKey} />
              ) : (
                <Input
                  className="Allinput !h-[25px] text-xs"
                  value={item?.shipWeight ?? ""}
                  onChange={(e) => onChange({ shipWeight: Number(e.target.value) || undefined })}
                  onBlur={onBlurSave}
                />
              )}
              <span className="text-xs">Lbs</span>
            </div>

            <div className="flex flex-col gap-1 mt-1">
              <Row gutter={24}>
                <Col span={12}>
                  <div className="flex gap-1 items-center">
                    <label className="text-xs w-20">Locations:</label>
                    {isFindMode ? (
                      <FI
                        className="Allinput !h-[25px] text-xs location-box-input"
                        value={fv.location}
                        onChange={(e) => onFindChange?.("location", e.target.value)}
                        onKeyDown={handleFindKey}
                      />
                    ) : (
                      <Input
                        className="Allinput !h-[25px] text-xs location-box-input"
                        value={item?.location || ""}
                        onChange={(e) => onChange({ location: e.target.value })}
                        onBlur={onBlurSave}
                      />
                    )}
                  </div>
                </Col>
                <Col span={12}>
                  <div className="flex items-center gap-1">
                    <label className="text-xs">Date</label>
                    <DatePicker
                      className="w-24 text-[10px]"
                      format="MM/DD/YYYY"
                      size="small"
                      value={
                        isFindMode
                          ? (fv.datePurchased ? dayjs(fv.datePurchased) : undefined)
                          : item?.datePurchased
                          ? dayjs(item.datePurchased)
                          : undefined
                      }
                      onChange={(value) => {
                        if (isFindMode) {
                          onFindChange?.("datePurchased", value ? value.toISOString() : "");
                        } else {
                          onChange({ datePurchased: value ? value.toISOString() : undefined });
                        }
                      }}
                      onBlur={isFindMode ? undefined : onBlurSave}
                    />
                  </div>
                </Col>
              </Row>
            </div>

            <div className="flex items-center gap-1 mt-1">
              <label className="text-xs">Accessories</label>
              <Input.TextArea
                style={{ resize: "none" }}
                className="text-xs"
                value={isFindMode ? fv.accessories : (item?.accessories || "")}
                onChange={(e) =>
                  isFindMode
                    ? onFindChange?.("accessories", e.target.value)
                    : onChange({ accessories: e.target.value })
                }
                onBlur={isFindMode ? undefined : onBlurSave}
              />
            </div>
          </div>
        </Col>

        <Col span={12} className="flex flex-col">
          <div className="flex flex-col gap-1 h-full">
            <label className="text-xs">Comment/Conditions</label>
            <Input.TextArea
              className="flex-grow text-xs comment-box-input"
              style={{ height: "100%", resize: "none" }}
              value={isFindMode ? fv.comments : (item?.comments || "")}
              onChange={(e) =>
                isFindMode
                  ? onFindChange?.("comments", e.target.value)
                  : onChange({ comments: e.target.value })
              }
              onBlur={isFindMode ? undefined : onBlurSave}
            />
          </div>
        </Col>
      </Row>

      {/* Row 5: Physical Details */}
      <Row>
        <Col span={24}>
          <div className="flex gap-1 items-center mt-1">
            <label className="mr-1 text-xs">WebSearch:</label>
            <Button className="text-xs" disabled={isFindMode} onClick={() => window.open(`https://www.google.com/search?q=${encodeURIComponent(item?.model || "")}`, "_blank")}>Google</Button>
            <Button className="text-xs" disabled={isFindMode} onClick={() => window.open(`https://www.used-line.com/search?q=${encodeURIComponent(item?.model || "")}`, "_blank")}>UL</Button>
            <Button className="text-xs" disabled={isFindMode} onClick={() => window.open(`https://www.used-line.com/search?q=${encodeURIComponent(item?.model || "")}`, "_blank")}>UL Prices</Button>
            <Button className="text-xs" disabled={isFindMode} onClick={() => window.open(`https://search.testmart.com/search/sitesearch.cfm?q=${encodeURIComponent(item?.model || "")}`, "_blank")}>TestMart</Button>
            <Button className="text-xs" disabled={isFindMode}>GDS.eMart</Button>
            <Button className="text-xs" disabled={isFindMode} onClick={() => window.open(`https://www.ebay.com/sch/i.html?_nkw=${encodeURIComponent(item?.model || "")}`, "_blank")}>eBay.Closed</Button>
            <Button className="text-xs" disabled={isFindMode} onClick={() => window.open(`https://www.ebay.com/sch/i.html?_nkw=${encodeURIComponent(item?.model || "")}`, "_blank")}>eBay</Button>
          </div>
        </Col>
      </Row>

      {/* Row 6 */}
      <Row>
        <Col span={24}>
          <span className="text-xs mr-2 text-red-500">
            Please Don't edit/fill the two Component fields, it's very critical.
            these are only for viewing:
          </span>
          <Button className="text-xs" onClick={onAddWts} disabled={isFindMode}>+ WTS</Button>
        </Col>
      </Row>

      {/* Row 7: Category */}
      <Row className="flex items-center gap-2">
        <Col span={9}>
          <div className="flex flex-col gap-1">
            <label className="text-xs">Main Category:</label>
            {isFindMode ? (
              <FI className="Allinput !h-[25px] text-xs main-category-box-input" value={fv.eqCategoriesCatName} onChange={(e) => onFindChange?.("eqCategoriesCatName", e.target.value)} onKeyDown={handleFindKey} />
            ) : (
              <Input
                className="Allinput !h-[25px] text-xs main-category-box-input"
                value={item?.eqCategoriesCatName || ""}
                readOnly
              />
            )}
          </div>
        </Col>
        <Col span={9}>
          <div className="flex gap-1 flex-col">
            <label className="text-xs">Sub Category:</label>
            {isFindMode ? (
              <FI className="Allinput !h-[25px] text-xs sub-category-box-input" value={fv.eqSubCategoriesSubCatName} onChange={(e) => onFindChange?.("eqSubCategoriesSubCatName", e.target.value)} onKeyDown={handleFindKey} />
            ) : (
              <Input
                className="Allinput !h-[25px] text-xs sub-category-box-input"
                value={item?.eqSubCategoriesSubCatName || ""}
                readOnly
              />
            )}
          </div>
        </Col>
        <Col span={5}>
          <span className="text-xs">invid {item?.invid ?? itemNumber}</span>
        </Col>
      </Row>
    </div>
  );
};

const InventoryPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [statusOptions, setStatusOptions] = useState<StatusOption[]>([]);
  const [manufacturerOptions, setManufacturerOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [inventoryItems, setInventoryItems] = useState<InventoryResponse[]>([]);
  const INV_STATE_KEY = "inventoryState";
  const _invSaved = (() => { try { return JSON.parse(localStorage.getItem(INV_STATE_KEY) || "null") || {}; } catch { return {}; } })();
  const [sortRules, setSortRules] = useState<SortRule[]>(() => normalizeSortRules(_invSaved.sortRules, INVENTORY_SORT_KEYS));
  const [totalCount, setTotalCount] = useState(0);
  const [unfilteredTotal, setUnfilteredTotal] = useState(_invSaved.unfilteredTotal || 0);
  const buildSortParams = (rules = sortRules) => {
    const sort = sortRulesToQuery(rules, INVENTORY_SORT_KEYS);
    return sort ? { sort } : {};
  };
  const [currentRowNumber, setCurrentRowNumber] = useState(_invSaved.currentRowNumber || 0);
  const invInitialRef = useRef(true);
  const [openRecordInput, setOpenRecordInput] = useState("");
  const [recordInputValue, setRecordInputValue] = useState("");
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [editingStatus, setEditingStatus] = useState({ index: -1, value: "" });
  const [newStatus, setNewStatus] = useState("");
  const [isNew, setIsNew] = useState(false);
  const [isFindMode, setIsFindMode] = useState(_invSaved.isFindMode || false);
  const emptyFindFields: FindValues = {
    manu: "", model: "", serialNumber: "", status: "", location: "", buyer: "",
    opt: "", desc: "", listPrice: "", quantity: "", cost: "", sellDealer: "",
    monthlyRental: "", endUserRental: "", shipWeight: "", accessories: "",
    comments: "", eqCategoriesCatName: "", eqSubCategoriesSubCatName: "", datePurchased: "",
  };
  const [findFields, setFindFields] = useState<FindValues>(_invSaved.findFields || emptyFindFields);
  const [filteredInventory, setFilteredInventory] = useState<
    InventoryResponse[] | null
  >(null);
  const [activeInventoryFilter, setActiveInventoryFilter] =
    useState<ActiveInventoryFilter>(_invSaved.activeInventoryFilter || { type: "none" });
  const autosaveTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const navBeltRef = useRef<HTMLDivElement | null>(null);
  const navBeltDragging = useRef(false);
  const [navBeltDragIdx, setNavBeltDragIdx] = useState<number | null>(null);

  const refreshInventoryStatuses = async () => {
    try {
      const statusResponse = await getStatuses();
      if (Array.isArray(statusResponse) && statusResponse.length > 0) {
        const mappedStatuses = statusResponse
          .filter((item) => item.type === STATUS_TYPE_INVENTORY)
          .map((item) => ({
            id: item.id,
            value: item.statusName,
            label: item.statusName,
            type: item.type,
          }));
        setStatusOptions(mappedStatuses);
      } else {
        setStatusOptions([]);
      }
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to load statuses",
      );
    }
  };

  const loadManufacturers = async () => {
    try {
      const data = await getManufacturers();
      const options = (Array.isArray(data) ? data : []).map((m: any) => ({
        value: m?.name,
        label: m?.name,
      }));
      setManufacturerOptions(options);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to load manufacturers",
      );
    }
  };

  const fetchInventories = async (limit = 1, rulesOverride = sortRules) => {
    try {
      const response = await getInventories({ page: 1, limit, ...buildSortParams(rulesOverride) });
      const list = response.data || [];
      setInventoryItems(list.length > 0 ? [list[0]] : []);
      const total = response.pagination?.total ?? list.length;
      setTotalCount(total);
      setUnfilteredTotal(total);
      setCurrentRowNumber(total > 0 ? 1 : 0);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to load inventory",
      );
    }
  };

  const loadInventoryByRow = async (rowNumber: number, rulesOverride = sortRules) => {
    if (!Number.isFinite(rowNumber) || rowNumber <= 0) return;
    if (Array.isArray(filteredInventory)) {
      const index = rowNumber - 1;
      if (index >= 0 && index < filteredInventory.length) {
        setInventoryItems([filteredInventory[index]]);
        setCurrentRowNumber(rowNumber);
      }
      return;
    }
    try {
      const response = await getInventories({ page: rowNumber, limit: 1, ...buildSortParams(rulesOverride) });
      const list = response.data || [];
      const total = response.pagination?.total ?? list.length;
      setInventoryItems(list);
      setTotalCount(total);
      setCurrentRowNumber(list.length > 0 ? rowNumber : 0);
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message || "Failed to load inventory record";
      message.error(errorMessage);
    }
  };

  const handleOpenRecordJump = async () => {
    const next = Number.parseInt(String(openRecordInput || "").trim(), 10);
    if (!Number.isFinite(next) || next < 1 || next > totalCount) {
      setOpenRecordInput(currentRowNumber > 0 ? String(currentRowNumber) : "");
      return;
    }
    await loadInventoryByRow(next);
  };

  const isInStock = (status: any) =>
    String(status || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "") === "instock";

  const handleFindAllInventory = async () => {
    setActiveInventoryFilter({ type: "none" });
    setFilteredInventory(null);
    setSortRules([]);
    if (searchParams.get("invid")) {
      navigate("/inventory", { replace: true });
    }
    await fetchInventories(1, []);
  };

  const applyFilteredInventory = (
    list: InventoryResponse[],
    totalOverride?: number,
  ) => {
    setFilteredInventory(list);
    setInventoryItems(list.length > 0 ? [list[0]] : []);
    const total = totalOverride ?? list.length;
    setTotalCount(total);
    setCurrentRowNumber(total > 0 ? 1 : 0);
  };

  const openFindPanel = () => {
    setFindFields(emptyFindFields);
    setIsFindMode(true);
  };

  const cancelFindPanel = () => {
    setIsFindMode(false);
    setFindFields(emptyFindFields);
  };

  const handlePerformFind = async () => {
    const f = findFields;
    const textFields = [
      f.manu, f.model, f.serialNumber, f.status, f.location, f.buyer,
      f.opt, f.desc, f.accessories, f.comments, f.endUserRental,
      f.eqCategoriesCatName, f.eqSubCategoriesSubCatName,
    ];
    const numericFields = [f.listPrice, f.quantity, f.cost, f.sellDealer, f.monthlyRental, f.shipWeight];
    const hasAny =
      textFields.some((v) => v.trim()) ||
      numericFields.some((v) => v.trim()) ||
      f.datePurchased.trim();
    if (!hasAny) {
      message.warning("Enter at least one search value");
      return;
    }
    try {
      const params: any = { page: 1, limit: 10000, ...buildSortParams() };
      // text fields
      if (f.manu.trim())                  params.manu = f.manu.trim();
      if (f.model.trim())                 params.model = f.model.trim();
      if (f.serialNumber.trim())          params.serialNumber = f.serialNumber.trim();
      if (f.status.trim())                params.status = f.status.trim();
      if (f.location.trim())              params.location = f.location.trim();
      if (f.buyer.trim())                 params.buyer = f.buyer.trim();
      if (f.opt.trim())                   params.opt = f.opt.trim();
      if (f.desc.trim())                  params.desc = f.desc.trim();
      if (f.accessories.trim())           params.accessories = f.accessories.trim();
      if (f.comments.trim())              params.comments = f.comments.trim();
      if (f.endUserRental.trim())         params.endUserRental = f.endUserRental.trim();
      if (f.eqCategoriesCatName.trim())   params.eqCategoriesCatName = f.eqCategoriesCatName.trim();
      if (f.eqSubCategoriesSubCatName.trim()) params.eqSubCategoriesSubCatName = f.eqSubCategoriesSubCatName.trim();
      // numeric fields
      const lp = parseFloat(f.listPrice);   if (!isNaN(lp))  params.listPrice = lp;
      const qty = parseInt(f.quantity, 10); if (!isNaN(qty)) params.quantity = qty;
      const co = parseFloat(f.cost);        if (!isNaN(co))  params.cost = co;
      const sd = parseFloat(f.sellDealer);  if (!isNaN(sd))  params.sellDealer = sd;
      const mr = parseFloat(f.monthlyRental); if (!isNaN(mr)) params.monthlyRental = mr;
      const sw = parseFloat(f.shipWeight);  if (!isNaN(sw))  params.shipWeight = sw;
      // date
      if (f.datePurchased.trim()) params.datePurchased = f.datePurchased.trim();

      const response = await getInventories(params);
      const matchedItems = response.data || [];
      const totalMatched = response.pagination?.total ?? matchedItems.length;
      applyFilteredInventory(matchedItems, totalMatched);
      setActiveInventoryFilter({ type: "model", value: f.model || f.manu || f.serialNumber || f.status || "search" });
      setIsFindMode(false);
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to search inventory");
    }
  };

  const handleFindInStockInventory = async () => {
    try {
      const response = await getInventories({ page: 1, limit: 10000, ...buildSortParams() });
      const allItems = response.data || [];
      const inStockItems = allItems.filter((item) => isInStock(item?.status));
      applyFilteredInventory(inStockItems, inStockItems.length);
      setActiveInventoryFilter({ type: "inStock" });
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to load in-stock inventory",
      );
    }
  };

  const reapplyCurrentFilter = async () => {
    if (activeInventoryFilter.type === "inStock") {
      await handleFindInStockInventory();
      return;
    }
    if (activeInventoryFilter.type === "model") {
      try {
        const response = await getInventories({
          page: 1,
          limit: 10000,
          search: activeInventoryFilter.value,
          ...buildSortParams(),
        });
        const matchedItems = response.data || [];
        const totalMatched =
          response.pagination?.total ?? matchedItems.length;
        applyFilteredInventory(matchedItems, totalMatched);
      } catch (error: any) {
        message.error(
          error?.response?.data?.message ||
            "Failed to refresh filtered inventory",
        );
      }
      return;
    }
    await fetchInventories(1);
  };

  const handleExportStockOnly = async () => {
    try {
      const fileBlob = await exportInventoryInStockExcel();
      const dateLabel = dayjs().format("YYYY-MM-DD");
      const filename = `inventory-in-stock-${dateLabel}.xlsx`;
      const url = window.URL.createObjectURL(fileBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      // message.success("In-stock inventory exported successfully");
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to export in-stock inventory",
      );
    }
  };

  const handleExportStockWithIncoming = async () => {
    try {
      const fileBlob = await exportInventoryStockWithIncomingExcel();
      const dateLabel = dayjs().format("YYYY-MM-DD");
      const filename = `inventory-stock-incoming-${dateLabel}.xlsx`;
      const url = window.URL.createObjectURL(fileBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to export stock with incoming inventory",
      );
    }
  };

  const handleScrollUp = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleLegacySort = () => {
    message.info("Sort is not connected yet.");
  };

  const handleDeleteCurrentInventory = async () => {
    const currentItem = Array.isArray(filteredInventory)
      ? filteredInventory[currentRowNumber - 1]
      : inventoryItems.length === 1
        ? inventoryItems[0]
        : inventoryItems[currentRowNumber - 1] || inventoryItems[0];

    if (!currentItem) {
      message.warning("No inventory record selected to delete");
      return;
    }

    const recordId = Number(currentItem?.invid || 0);

    // If current row is a local/unsaved record, just discard it and reload.
    if (!Number.isFinite(recordId) || recordId <= 0) {
      setIsNew(false);
      if (Array.isArray(filteredInventory)) await reapplyCurrentFilter();
      else await loadLatestInventory();
      return;
    }

    const confirmed = window.confirm(
      "Are you sure you want to delete this inventory record?",
    );
    if (!confirmed) return;

    try {
      await deleteInventory(recordId);
      // message.success("Inventory record deleted successfully");

      if (Array.isArray(filteredInventory)) await reapplyCurrentFilter();
      else await fetchInventories(1);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to delete inventory record",
      );
    }
  };

  const sanitizeCreatePayload = (item: InventoryResponse) => {
    const payload: any = { ...item };
    if (!payload?.invid || Number(payload.invid) <= 0) {
      delete payload.invid;
    }
    return payload;
  };

  const upsertInventorySilently = async (
    item: InventoryResponse | undefined,
    containerIndex = 0,
  ) => {
    if (!item) return;

    try {
      const numericId = Number(item?.invid || 0);
      if (numericId <= 0) return;
      await updateInventory(numericId, item);
    } catch (error) {
      console.error("Silent inventory upsert failed", error);
    }
  };

  const queueInventoryAutosave = (
    item: InventoryResponse | undefined,
    containerIndex = 0,
  ) => {
    if (autosaveTimerRef.current) {
      clearTimeout(autosaveTimerRef.current);
    }
    autosaveTimerRef.current = setTimeout(() => {
      upsertInventorySilently(item, containerIndex);
    }, 700);
  };

  const handleNewInventory = async () => {
    try {
      if (autosaveTimerRef.current) {
        clearTimeout(autosaveTimerRef.current);
      }

      const latest = await getLatestInventory();
      const latestInvid = Number(latest?.invid || 0);
      const nextInvid = Number.isFinite(latestInvid) ? latestInvid + 1 : 1;

      const newItem = {
        ...getEmptyInventory(),
        invid: nextInvid,
      };

      const created = await createInventory(sanitizeCreatePayload(newItem));
      setInventoryItems([created || newItem]);
      setIsNew(false);
      setFilteredInventory(null);
      setActiveInventoryFilter({ type: "none" });
      const newTotal = totalCount + 1;
      setTotalCount(newTotal);
      setCurrentRowNumber(newTotal);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to create new inventory record",
      );
    }
  };

  const loadLatestInventory = async () => {
    await fetchInventories(1);
  };

  const loadInventoryById = async (id: number) => {
    if (!Number.isFinite(id) || id <= 0) return;
    try {
      const record = await getInventoryById(id);
      if (record) {
        setInventoryItems([record]);
        setFilteredInventory(null);
        setTotalCount(1);
        setUnfilteredTotal(1);
        setCurrentRowNumber(1);
      }
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Inventory not found");
    }
  };

  useEffect(() => {
    if (!invInitialRef.current) {
      localStorage.setItem(INV_STATE_KEY, JSON.stringify({ currentRowNumber, isFindMode, findFields, activeInventoryFilter, unfilteredTotal, sortRules }));
    }
  }, [currentRowNumber, isFindMode, findFields, activeInventoryFilter, unfilteredTotal, sortRules]);

  useEffect(() => {
    const initInventory = async () => {
      await refreshInventoryStatuses();
      await loadManufacturers();

      // If navigated here with ?invid=, show only that record (count=1, no nav)
      const targetInvid = Number(searchParams.get("invid"));
      if (Number.isFinite(targetInvid) && targetInvid > 0) {
        await loadInventoryById(targetInvid);
        invInitialRef.current = false;
        return;
      }

      const savedFilter = _invSaved.activeInventoryFilter;
      const savedRow = _invSaved.currentRowNumber || 1;

      if (savedFilter?.type === "inStock") {
        // Re-apply in-stock filter
        try {
          const response = await getInventories({ page: 1, limit: 10000, ...buildSortParams() });
          const allItems = response.data || [];
          const inStockItems = allItems.filter((item: any) =>
            String(item?.status || "").trim().toLowerCase().replace(/\s+/g, "") === "instock"
          );
          setFilteredInventory(inStockItems);
          const total = inStockItems.length;
          setTotalCount(total);
          setUnfilteredTotal(_invSaved.unfilteredTotal || total);
          const safeRow = Math.min(savedRow, total);
          setCurrentRowNumber(safeRow > 0 ? safeRow : 1);
          setInventoryItems(inStockItems.length > 0 ? [inStockItems[Math.max(0, safeRow - 1)]] : []);
          setActiveInventoryFilter({ type: "inStock" });
        } catch { await loadLatestInventory(); }

      } else if (savedFilter?.type === "model") {
        // Re-apply find filter using saved findFields
        const f = _invSaved.findFields || {};
        const params: any = { page: 1, limit: 10000, ...buildSortParams() };
        if (f.manu?.trim())                      params.manu = f.manu.trim();
        if (f.model?.trim())                     params.model = f.model.trim();
        if (f.serialNumber?.trim())              params.serialNumber = f.serialNumber.trim();
        if (f.status?.trim())                    params.status = f.status.trim();
        if (f.location?.trim())                  params.location = f.location.trim();
        if (f.buyer?.trim())                     params.buyer = f.buyer.trim();
        if (f.opt?.trim())                       params.opt = f.opt.trim();
        if (f.desc?.trim())                      params.desc = f.desc.trim();
        if (f.accessories?.trim())               params.accessories = f.accessories.trim();
        if (f.comments?.trim())                  params.comments = f.comments.trim();
        if (f.endUserRental?.trim())             params.endUserRental = f.endUserRental.trim();
        if (f.eqCategoriesCatName?.trim())       params.eqCategoriesCatName = f.eqCategoriesCatName.trim();
        if (f.eqSubCategoriesSubCatName?.trim()) params.eqSubCategoriesSubCatName = f.eqSubCategoriesSubCatName.trim();
        const hasParams = Object.keys(params).length > 2;
        if (hasParams) {
          try {
            const response = await getInventories(params);
            const matchedItems = response.data || [];
            const total = response.pagination?.total ?? matchedItems.length;
            setFilteredInventory(matchedItems);
            setTotalCount(total);
            setUnfilteredTotal(_invSaved.unfilteredTotal || total);
            const safeRow = Math.min(savedRow, total);
            setCurrentRowNumber(safeRow > 0 ? safeRow : 1);
            setInventoryItems(matchedItems.length > 0 ? [matchedItems[Math.max(0, safeRow - 1)]] : []);
            setActiveInventoryFilter({ type: "model", value: savedFilter.value });
          } catch { await loadLatestInventory(); }
        } else {
          await loadLatestInventory();
        }

      } else if (sortRules.length > 0) {
        await fetchInventories(1);
        if (savedRow > 1) await loadInventoryByRow(savedRow);
      } else if (savedRow > 1) {
        await fetchInventories(1);
        await loadInventoryByRow(savedRow);
      } else {
        await loadLatestInventory();
      }
      invInitialRef.current = false;
    };
    initInventory();
  }, []);

  useEffect(() => {
    setOpenRecordInput(
      currentRowNumber > 0 ? String(currentRowNumber) : "",
    );
  }, [currentRowNumber]);

  useEffect(() => {
    return () => {
      if (autosaveTimerRef.current) {
        clearTimeout(autosaveTimerRef.current);
      }
    };
  }, []);

  const handleEditStatus = (index: number) => {
    setEditingStatus({ index, value: statusOptions[index].label });
  };

  const handleSaveStatus = async () => {
    if (editingStatus.index < 0 || !editingStatus.value.trim()) return;
    const targetStatus = statusOptions[editingStatus.index];
    if (!targetStatus?.id) return;

    try {
      await updateStatus(targetStatus.id, {
        statusName: editingStatus.value.trim(),
        type: STATUS_TYPE_INVENTORY,
      });
      // message.success("Status updated successfully");
      setEditingStatus({ index: -1, value: "" });
      await refreshInventoryStatuses();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to update status",
      );
    }
  };

  const handleAddStatus = async () => {
    if (!newStatus.trim()) return;
    try {
      await createStatus({
        statusName: newStatus.trim(),
        type: STATUS_TYPE_INVENTORY,
      });
      // message.success("Status added successfully");
      setNewStatus("");
      await refreshInventoryStatuses();
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to add status");
    }
  };

  const handleDeleteStatus = async (index: number) => {
    const targetStatus = statusOptions[index];
    if (!targetStatus?.id) return;
    try {
      await deleteStatus(targetStatus.id);
      // message.success("Status deleted successfully");
      await refreshInventoryStatuses();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to delete status",
      );
    }
  };

  // Tabs Configuration for Section 3
  const buildTabItems = (item: InventoryResponse | undefined, onChange: (patch: Partial<InventoryResponse>) => void) => [
    {
      key: "1",
      label: "Details",
      children: (
        <div className="p-3 rounded-b-xl min-h-[400px]">
          <span className="font-bold border-b border-gray-300 text-xs">
            {">>"} Condition and Calibration Configuration:
          </span>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <div className="flex items-center gap-2 mt-3 ml-2">
                <label className="text-xs w-20">Condition:</label>
                <Input
                  size="small"
                  className="Allinput !h-[25px] text-xs"
                  value={item?.condition ?? ""}
                  onChange={(e) => onChange({ condition: e.target.value })}
                />
              </div>
            </Col>
            <Col span={12}>
              <div className="flex items-center gap-2 mt-3">
                <label className="text-xs w-24">User Manual:</label>
                <Radio.Group
                  size="small"
                  value={item?.userManual === 1 ? "yes" : "no"}
                  onChange={(e) => onChange({ userManual: e.target.value === "yes" ? 1 : 0 })}
                >
                  <Radio value="no" className="text-xs">No</Radio>
                  <Radio value="yes" className="text-xs">Yes</Radio>
                </Radio.Group>
              </div>
            </Col>
            <Col span={12}>
              <div className="flex items-center gap-2 ml-2">
                <label className="text-xs w-20">Calibrated:</label>
                <Radio.Group
                  size="small"
                  value={item?.calcStatus === 1 ? "yes" : "no"}
                  onChange={(e) => onChange({ calcStatus: e.target.value === "yes" ? 1 : 0 })}
                >
                  <Radio value="no" className="text-xs">No</Radio>
                  <Radio value="yes" className="text-xs">Yes</Radio>
                </Radio.Group>
              </div>
            </Col>
            <Col span={12}>
              <div className="flex items-center gap-2">
                <label className="text-xs w-24">Functional:</label>
                <Radio.Group
                  size="small"
                  value={item?.functional === 1 ? "yes" : "no"}
                  onChange={(e) => onChange({ functional: e.target.value === "yes" ? 1 : 0 })}
                >
                  <Radio value="no" className="text-xs">No</Radio>
                  <Radio value="yes" className="text-xs">Yes</Radio>
                </Radio.Group>
              </div>
            </Col>
            <Col span={12}>
              <div className="flex items-center gap-2 ml-2">
                <label className="text-xs w-20">Calibration Cart:</label>
                <Radio.Group
                  size="small"
                  value={item?.calcCert === 1 ? "yes" : "no"}
                  onChange={(e) => onChange({ calcCert: e.target.value === "yes" ? 1 : 0 })}
                >
                  <Radio value="no" className="text-xs">No</Radio>
                  <Radio value="yes" className="text-xs">Yes</Radio>
                </Radio.Group>
              </div>
            </Col>
            <Col span={12}>
              <div className="flex items-center gap-2">
                <label className="text-xs w-20">Calibration Date:</label>
                <DatePicker
                  size="small"
                  className="text-xs"
                  value={item?.calcDate ? dayjs(item.calcDate) : null}
                  onChange={(_, dateStr) => onChange({ calcDate: dateStr ? String(dateStr) : null })}
                />
              </div>
            </Col>
            <Col span={12}>
              <div className="flex items-center gap-2 ml-2">
                <label className="text-xs w-20">Cal Cert By:</label>
                <Input
                  size="small"
                  className="Allinput !h-[25px] text-xs"
                  value={item?.calcCertBy ?? ""}
                  onChange={(e) => onChange({ calcCertBy: e.target.value })}
                />
              </div>
            </Col>
            <Col span={12}>
              <div className="flex items-center gap-2">
                <label className="text-xs w-20">Calibration Till:</label>
                <DatePicker
                  size="small"
                  className="text-xs"
                  value={item?.calcValidDate ? dayjs(item.calcValidDate) : null}
                  onChange={(_, dateStr) => onChange({ calcValidDate: dateStr ? String(dateStr) : null })}
                />
              </div>
            </Col>
            <Col span={24}>
              <Col className="mb-2">
                <span className="font-bold border-b border-gray-300 text-xs">
                  {">>"} Web Publishing Details:
                </span>
              </Col>
              <Col>
                <span className="font-bold border-b border-gray-300 ml-2 text-xs">
                  {"**"} TestMart:
                </span>
              </Col>
            </Col>
            <Col span={12}>
              <div className="flex items-center gap-2 ml-6">
                <label className="text-xs w-24">Test Mart Price:</label>
                <Input
                  size="small"
                  className="Allinput !h-[25px] text-xs w-24"
                  value={item?.tmartPrice ?? ""}
                  onChange={(e) => onChange({ tmartPrice: e.target.value === "" ? null : Number(e.target.value) })}
                />
              </div>
            </Col>
            <Col span={12}>
              <label className="text-xs">(Auto calculated Sell EU + 8%)</label>
            </Col>
            <Col span={12}>
              <div className="flex items-center gap-2 ml-6">
                <label className="text-xs w-24">TestMart Show:</label>
                <Radio.Group
                  size="small"
                  value={item?.tmartShow === 1 ? "yes" : "no"}
                  onChange={(e) => onChange({ tmartShow: e.target.value === "yes" ? 1 : 0 })}
                >
                  <Radio value="no" className="text-xs">No</Radio>
                  <Radio value="yes" className="text-xs">Yes</Radio>
                </Radio.Group>
              </div>
            </Col>
          </Row>
        </div>
      ),
    },
    {
      key: "2",
      label: "General Options",
      children: (
        <div className="p-3">
          <div className="font-bold text-xs border-b border-gray-300 mb-2">{"**"} TestMart:</div>
          {[
            { label: "Country:", field: "tmartCountry" },
            { label: "User Name:", field: "tmartUsername" },
            { label: "Ship Time:", field: "tmartShipTime" },
            { label: "Location Zip:", field: "tmartLocationZip" },
            { label: "Warranty:", field: "tmartWarrenty" },
          ].map(({ label, field }) => (
            <div key={field} className="flex items-center mb-1">
              <label className="text-xs text-right pr-2 shrink-0" style={{ width: 88 }}>{label}</label>
              <Input
                size="small"
                className="Allinput !h-[22px] text-xs flex-1"
                value={(item as any)?.[field] ?? ""}
                onChange={(e) => onChange({ [field]: e.target.value })}
              />
            </div>
          ))}
        </div>
      ),
    },
  ];

  const isFilterActive = activeInventoryFilter.type !== "none";

  useEffect(() => {
    setRecordInputValue(totalCount > 0 ? String(currentRowNumber) : "");
  }, [currentRowNumber, totalCount]);

  const handleRecordInputCommit = (value: string) => {
    const parsed = Number.parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed < 1 || parsed > totalCount) {
      setRecordInputValue(totalCount > 0 ? String(currentRowNumber) : "");
      return;
    }
    loadInventoryByRow(parsed);
  };

  const handleApplySortRules = async (rules: SortRule[]) => {
    const normalized = normalizeSortRules(rules, INVENTORY_SORT_KEYS);
    setSortRules(normalized);
    setFilteredInventory(null);
    setActiveInventoryFilter({ type: "none" });
    await fetchInventories(1, normalized);
  };

  // Number of inventory items to display
  const containerCount = inventoryItems.length;
  return (
    <div className="inventory-page bg-slate-50 min-h-screen">
      <CommonHeader
        className="mb-0"
        currentRecord={recordInputValue}
        disableNext={currentRowNumber >= totalCount}
        disablePrevious={currentRowNumber <= 1}
        isFindMode={isFindMode}
        onCancelFind={cancelFindPanel}
        onDeleteRecord={handleDeleteCurrentInventory}
        onFind={openFindPanel}
        onNewRecord={handleNewInventory}
        onNextRecord={() => loadInventoryByRow(currentRowNumber + 1)}
        onPerformFind={handlePerformFind}
        onPreviousRecord={() => loadInventoryByRow(currentRowNumber - 1)}
        onRecordChange={setRecordInputValue}
        onRecordCommit={handleRecordInputCommit}
        onRecordSliderCommit={(index) => loadInventoryByRow(index + 1)}
        onShowAll={handleFindAllInventory}
        recordCount={totalCount}
        recordIndex={Math.max(0, currentRowNumber - 1)}
        rightContent={<PageLogoutButton className="inventory-logout-btn" />}
        totalActiveCount={totalCount}
        totalLabel={isFilterActive ? "Filtered" : (sortRules.length > 0 ? "Total (Sorted)" : "Total (Unsorted)")}
        totalRecordCount={unfilteredTotal}
        totalValue={isFilterActive ? `${totalCount} / ${unfilteredTotal}` : totalCount}
        sortColumns={INVENTORY_EXPORT_COLUMNS}
        sortTitle="Sort Inventory Records"
        sortRules={sortRules}
        onApplySort={handleApplySortRules}
        exportColumns={INVENTORY_EXPORT_COLUMNS}
        getData={() => filteredInventory || inventoryItems}
        onImport={async (data) => { await bulkImportInventory(data); }}
        exportFilename="inventory"
      />
      <div className="mb-4 overflow-x-auto border border-gray-300 bg-white px-[4px] py-[4px]">
        <div className="flex min-w-[1420px] items-start justify-between gap-6 whitespace-nowrap">
          <div className="flex items-start gap-6">
            <Button
              size="small"
              className="!mt-[2px] !h-[36px] !min-w-[54px] !rounded-[10px] px-3 !text-[12px]"
              onClick={handleNewInventory}
            >
              NEW
            </Button>

            <div className="flex flex-col items-center gap-[8px]">
              <h1 className="text-[18px] font-semibold leading-none text-black">
                Receiving/Inventory Log
              </h1>
              <div className="flex items-center gap-[4px]">
                <Button
                  size="small"
                  className="!h-[22px] !min-w-[44px] !rounded-none px-2 !text-[11px]"
                  onClick={handleLegacySort}
                >
                  SORT
                </Button>
                <Button
                  size="small"
                  className="!h-[22px] !min-w-[52px] !rounded-none px-2 !text-[11px]"
                  onClick={handleFindAllInventory}
                >
                  Find All
                </Button>
                <Button
                  size="small"
                  className="!h-[22px] !min-w-[76px] !rounded-none px-2 !text-[11px]"
                  onClick={handleScrollUp}
                >
                  Scroll Up
                </Button>
              </div>
            </div>

            <div className="flex items-start gap-[12px] pt-[2px]">
              <Button
                size="small"
                className="!mt-[2px] !h-[36px] !min-w-[54px] !rounded-[10px] px-3 !text-[12px]"
                onClick={openFindPanel}
              >
                FIND
              </Button>
              <Button
                size="small"
                className="!h-[22px] !min-w-[100px] !rounded-none px-2 !text-[11px]"
                onClick={handleFindInStockInventory}
              >
                FIND IN STOCK
              </Button>
              <Button
                size="small"
                className="!h-[22px] !min-w-[106px] !rounded-none px-2 !text-[11px]"
                onClick={handleExportStockOnly}
              >
                Get TestMart XLS
              </Button>
              <Button
                size="small"
                className="!h-[22px] !min-w-[102px] !rounded-none px-2 !text-[11px]"
                onClick={() => navigate("/quotes-responses")}
              >
                WTB Responses
              </Button>
            </div>
          </div>

          <div className="flex items-start gap-4 pr-2">
            <div className="flex flex-col gap-[6px] pt-[2px]">
              <Button
                size="small"
                className="!h-[22px] !min-w-[72px] !rounded-none px-2 !text-[11px]"
                onClick={() => navigate("/Quotes")}
              >
                Quotes
              </Button>
              <Button
                size="small"
                className="!h-[22px] !min-w-[58px] !rounded-none px-2 !text-[11px]"
              >
                EQR
              </Button>
            </div>

            <Button
              size="small"
              className="!mt-[2px] !h-[22px] !min-w-[122px] !rounded-none px-2 !text-[11px]"
              onClick={() => navigate("/open-order")}
            >
              Open Order Report
            </Button>
          </div>
        </div>
      </div>

      {/* THE MAIN CONTAINER ROW (Total 24) */}
      {inventoryItems.map((item, containerIndex) => (
        <React.Fragment key={item.invid ?? containerIndex}>
          <Row gutter={[24, 24]} className="bg-white">
            {/* --- PART 1: MAIN FORM SECTION --- */}
            <Col span={11}>
              <div className="max-h-[80vh] overflow-y-auto pr-2">
                <InventoryItem
                  item={item}
                  statusOptions={statusOptions}
                  manufacturerOptions={manufacturerOptions}
                  isFindMode={isFindMode}
                  findValues={findFields}
                  onFindChange={(field, value) =>
                    setFindFields((prev) => ({ ...prev, [field]: value }))
                  }
                  onPerformFind={handlePerformFind}
                  onOpenStatusModal={() => setIsStatusModalOpen(true)}
                  onChange={(patch) => {
                    const nextItem = { ...item, ...patch };
                    setInventoryItems((prev) =>
                      prev.map((it, i) =>
                        i === containerIndex ? { ...it, ...patch } : it,
                      ),
                    );
                    if (Number(nextItem?.invid || 0) > 0) {
                      queueInventoryAutosave(nextItem, containerIndex);
                    }
                  }}
                  onBlurSave={async () => {
                    const currentItem = inventoryItems[containerIndex];
                    await upsertInventorySilently(currentItem, containerIndex);
                  }}
                  onAddWts={async () => {
                    try {
                      const payload = {
                        eqBrand: item?.manu || undefined,
                        eqModel: item?.model || undefined,
                        eqOptions: item?.opt || undefined,
                        listType: "WTS",
                        type: "WTS",
                        status: "Active",
                        recordId: item?.invid || undefined,
                        source: item?.desc || undefined,
                      };
                      const saved = await createQuoteWtb(payload);
                      // message.success(
                      //   `WTS record created (ID: ${saved.id || saved.qid})`,
                      // );
                    } catch (error: any) {
                      message.error(
                        error?.response?.data?.message ||
                          "Failed to create WTS record",
                      );
                    }
                  }}
                />
              </div>
            </Col>

            {/* --- PART 2: CENTER ACTION BUTTONS --- */}
            <Col span={3}>
              <div className="bg-white flex flex-col gap-4 pt-20">
                <div className="w-full text-center items-center">
                  <Button
                    type="primary"
                    className="bg-[#004AAD] text-white"
                    onClick={handleExportStockOnly}
                  >
                    Export Stock only
                  </Button>
                </div>
                <div className="w-full text-center">
                  <Button type="primary" className=" bg-[#004AAD] text-white" onClick={handleExportStockWithIncoming}>
                    Export Stock w/Income
                  </Button>
                </div>
              </div>
            </Col>

            {/* --- PART 3: RIGHT DETAIL PANEL --- */}
            <Col span={10} className="mt-1">
              <div className="bg-white p-2 min-h-[500px]">
                <Tabs
                  type="card"
                  items={buildTabItems(item, (patch) => {
                    const nextItem = { ...item, ...patch };
                    setInventoryItems((prev) =>
                      prev.map((it, i) => i === containerIndex ? { ...it, ...patch } : it),
                    );
                    if (Number(nextItem?.invid || 0) > 0) {
                      queueInventoryAutosave(nextItem, containerIndex);
                    }
                  })}
                  className="inventory-tabs border border-gray-300 rounded-xl"
                  size="small"
                  tabBarExtraContent={
                    <div className="flex items-center gap-1 pr-2">
                      <label className="text-xs whitespace-nowrap">Publication Control:</label>
                      <Input
                        size="small"
                        className="Allinput !h-[22px] w-16 text-xs"
                        value={item?.publishControl ?? ""}
                        onChange={(e) => {
                          const patch = { publishControl: e.target.value === "" ? null : Number(e.target.value) };
                          const nextItem = { ...item, ...patch };
                          setInventoryItems((prev) =>
                            prev.map((it, i) => i === containerIndex ? { ...it, ...patch } : it),
                          );
                          if (Number(nextItem?.invid || 0) > 0) {
                            queueInventoryAutosave(nextItem, containerIndex);
                          }
                        }}
                      />
                    </div>
                  }
                />
              </div>
            </Col>
          </Row>

          {/* 🔹 Divider between repeated containers */}
          {containerIndex !== containerCount - 1 && (
            <div className="border-b border-gray-800" />
          )}
        </React.Fragment>
      ))}

      {isStatusModalOpen && (
        <>
          <div
            className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30"
            onClick={() => setIsStatusModalOpen(false)}
          />
          <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
            <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-80 max-h-96 overflow-hidden">
              <div className="p-3 border-b border-gray-200 flex justify-between items-center">
                <h3 className="text-[12px] font-semibold text-gray-700">
                  Edit Status Options
                </h3>
                <Button
                  type="text"
                  size="small"
                  className="h-5 w-5 p-0 text-gray-400 hover:text-gray-600"
                  onClick={() => setIsStatusModalOpen(false)}
                >
                  x
                </Button>
              </div>

              <div className="p-3 max-h-64 overflow-y-auto">
                <div className="space-y-2 mb-3">
                  {statusOptions.map((option, index) => (
                    <div
                      key={option.id ?? index}
                      className="flex items-center gap-1 group"
                    >
                      {editingStatus.index === index ? (
                        <>
                          <Input
                            value={editingStatus.value}
                            onChange={(e) =>
                              setEditingStatus({
                                ...editingStatus,
                                value: e.target.value,
                              })
                            }
                            size="small"
                            className="h-6 text-[10px] flex-1"
                            autoFocus
                            onPressEnter={handleSaveStatus}
                          />
                          <Button
                            type="primary"
                            size="small"
                            className="h-5 w-5 p-0 flex items-center justify-center bg-green-600 hover:bg-green-700"
                            onClick={handleSaveStatus}
                          >
                            <span className="text-[10px]">✓</span>
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-5 w-5 p-0 flex items-center justify-center text-gray-500"
                            onClick={() =>
                              setEditingStatus({ index: -1, value: "" })
                            }
                          >
                            <span className="text-[10px]">x</span>
                          </Button>
                        </>
                      ) : (
                        <>
                          <span className="text-[10px] flex-1">
                            {option.label}
                          </span>
                          <div className="flex gap-1">
                            <Button
                              type="text"
                              size="small"
                              className="h-4 w-4 p-0 flex items-center justify-center text-gray-400 hover:text-blue-600"
                              onClick={() => handleEditStatus(index)}
                            >
                              <EditOutlined className="text-[12px]" />
                            </Button>
                            <Button
                              type="text"
                              size="small"
                              className="h-4 w-4 p-0 flex items-center justify-center text-gray-400 hover:text-red-600"
                              onClick={() => handleDeleteStatus(index)}
                            >
                              <DeleteOutlined className="text-[12px]" />
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>

                <div className="border-t border-gray-200 pt-2">
                  <div className="text-[10px] font-medium text-gray-500 mb-1">
                    Add New Status
                  </div>
                  <div className="flex items-center gap-1">
                    <Input
                      placeholder="Enter new status"
                      value={newStatus}
                      onChange={(e) => setNewStatus(e.target.value)}
                      size="small"
                      className="h-6 text-[10px] flex-1"
                      onPressEnter={handleAddStatus}
                    />
                    <Button
                      type="primary"
                      size="small"
                      className="h-6 px-2 text-[9px] bg-[#004aad]"
                      onClick={handleAddStatus}
                    >
                      Add
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default InventoryPage;
